module.exports = __webpack_public_path__ + "static/Q2_2023_Announcement_Financial_Results-fa63434ad06ce03d92321409219d7f0a.pdf";